import styled, { css } from 'styled-components';

const SearchInputButtonCss = css`
    background: transparent;
    border: none;
    color: #c4ccd3;
    line-height: 1;
    margin: ${({ margin }) => margin || 0};
    outline: 0;
    padding: 8px 10px;
    position: relative;
    text-decoration: none;
    &:hover {
        color: #98a6b2;
        cursor: pointer;
    }
    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
    /**
     * Add styles for disabled and read-only
     */
    &[disabled],
    &[readonly] {
        background-color: #e1e5e9 !important;
        border-color: transparent;
        box-shadow: none;
        cursor: not-allowed;
        user-select: none;
        &:hover {
            color: #c4ccd3;
            cursor: not-allowed;
        }
    }
`;

const SearchInputButton = styled.button`
    ${SearchInputButtonCss};
`;

export default SearchInputButton;
